import {StorageService} from "./storage";
import {Api, AppSettings} from "../settings";
import http from './api';
import {isSuccessResponse, toastHelper} from '../shared';

const signOut = async () => {
  const response = await http.delete(Api.signOut, { target: 'alf'});

  if(isSuccessResponse(response)) {
    StorageService.removeItem(AppSettings.ticketName);
    return;
  }

  toastHelper.error('Lo sentimos no hemos podido deloguear su usuario');
};

export const persistAuthenticationToken = (token) => {
  StorageService.setItem(AppSettings.ticketName, token);
};

export const AuthService = {
  signOut,
  persistAuthenticationToken
};

export default AuthService;
